// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"521":"928ab1e1","677":"208dfe0d"}[chunkId] + ".chunk.css";
};